import { Box, Checkbox, Radio } from 'front-end/src/components'
import IconTick from 'front-end/src/components/common/icon/IconTick'
import IconX from 'front-end/src/components/common/icon/IconX'
import React from 'react'

import { QuizTooltip } from './QuizTooltip'

export const QuizOption = ({
  option,
  existingOptionResponse,
  isSelected,
  isMultiChoice,
  isOpen,
  quizResponse,
  optionClickHandler,
  allowRetry
}) => {
  const answerShouldBeCheck =
    existingOptionResponse &&
    !existingOptionResponse.is_correct &&
    existingOptionResponse.value === false

  return (
    <>
      <div className="QuizElement__option__wrapper">
        <Box
          className="QuizElement__option__toggle"
          filter={
            // Efficient way how to create more contrast variant for Checkbox/Radio
            existingOptionResponse ? 'brightness(75%) contrast(2)' : 'none'
          }
        >
          {isMultiChoice || isOpen ? (
            <Checkbox
              size="md"
              isChecked={isSelected}
              isDisabled={existingOptionResponse}
              onChange={optionClickHandler}
            />
          ) : (
            <Radio
              variant="withTickbox"
              size="md"
              isChecked={isSelected}
              isDisabled={existingOptionResponse}
              onChange={optionClickHandler}
              name={option.id}
            />
          )}
        </Box>
        <div
          className="QuizElement__option__content"
          dangerouslySetInnerHTML={{ __html: option.content }}
        />
        {!allowRetry && existingOptionResponse && (
          <div className="QuizElement__option__mark">
            <QuizTooltip quizResponse={existingOptionResponse}>
              {isSelected && existingOptionResponse?.is_correct && <IconTick />}
              {!isSelected && answerShouldBeCheck && <IconTick />}
              {isSelected && !existingOptionResponse?.is_correct && <IconX />}
            </QuizTooltip>
          </div>
        )}
      </div>
      {quizResponse && option.feedback && isSelected && (
        <div className="QuizElement__option-feedback-wrapper">
          <div className="QuizElement__option-feedback">
            <div className="QuizElement__option-feedback-arrow" />
            <div
              className="QuizElement__option-feedback-text"
              dangerouslySetInnerHTML={{
                __html: option.feedback
              }}
            />
          </div>
        </div>
      )}
    </>
  )
}
